// extracted by mini-css-extract-plugin
module.exports = {"stripes":"style_stripes__3lCNX"};